import { getButton } from '../native/Button';
import styles from '../styles/Styles';

/**
  ALERT DIALOG BODY :
  title = (string);
  message = (string);
  btn_message = (string);
  listener = (function);
**/

function alertAction(context) {
  if (context.state.alert_dialog.listener === null) {
    context.setState({ alert_dialog : null });
  } else {
    context.state.alert_dialog.listener();
  }
}

export function showAlertDialog(context) {
  if (context.state.alert_dialog === undefined) { context.state.alert_dialog = null; }
  if (context.state.alert_dialog !== null) {
    return (
      <div onClick={() => alertAction(context)} style={m_style.root_dialog} >
        <div onClick={(e) => e.stopPropagation()} style={m_style.dialog_container}>
          <div style={{flex : 1, display : 'flex', flexDirection : 'column', padding : 20}}>
            <div className='crs_default fnt_blk_a txt_20 txt_bold'><span>{context.state.alert_dialog.title}</span></div>
            <div className='fnt_blk_a txt_14 crs_default' style={{padding : '20px 0'}}>{context.state.alert_dialog.message}</div>
            <div style={{display : 'flex', flexDirection : 'row', justifyContent : 'flex-end'}}>
              { getButton({text : context.state.alert_dialog.btn_message, text_class : 'fnt_ntv_a txt_14', inner_style : {width : 60}}, () => alertAction(context)) }
            </div>
          </div>
        </div>
      </div>
    );
  } else { return null; }
}

export function AlertDialog({open,title,message,btn_message,icon,action=()=>{}}) {
  if (open !== null) {
    return (
      <div style={m_style.root_dialog}>
        <div style={m_style.dialog_container}>
          <div style={{padding : 20}}>
            <div className='crs_default fnt_ntv_a txt_20 txt_bold' style={{textAlign : 'center'}}><span>{title}</span></div>
            {icon ? <div style={{display : 'flex', flexDirection : 'row', margin : '20px 0'}}>
              <img alt='' src={icon} height={100} style={{margin : '30px auto 30px'}}/>
            </div> :null}
            <div className='fnt_blk_a txt_12 crs_default' style={{margin : '15px 0 15px 0', textAlign : 'center', wordWrap : 'break-word'}}><span>{ message }</span></div>
            
            { getButton({text : btn_message, text_class : 'txt_14 fnt_wht_a', inner_style : {...styles.ntv_bg_color_b, ...{borderRadius : 10}}}, () => action()) }
          </div>
        </div>
      </div>
    );
  } else { return null; }
}

const m_style = {
  root_dialog : {
    display : 'flex',
    flexDirection : 'column',
    position : 'fixed',
    overflow : 'auto',
    zIndex : 4,
    top : 0, left : 0,
    width : '100%',
    height : '100%',
    backgroundColor : 'rgba(0, 0, 0, 0.5)'
  },
  dialog_container : {
    display : 'flex',
    flexDirection : 'column',
    width : '80%',
    maxWidth : 300,
    backgroundColor : 'white',
    borderRadius : 10,
    margin : 'auto'
  }
}
